import React from 'react';

interface StepperProps {
  steps: string[];
  current: number;
}

const Stepper: React.FC<StepperProps> = ({ steps, current }) => (
  <div className="flex items-center gap-2">
    {steps.map((step, i) => {
      const done = i < current;
      const active = i === current;
      return (
        <React.Fragment key={i}>
          <div className="flex items-center gap-2">
            <div
              className={`w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-bold flex-none
                ${done ? 'bg-forest-900 text-white' : active ? 'bg-teal-400 text-forest-900' : 'bg-ink-200 text-ink-500'}`}
            >
              {done ? (
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12l5 5L20 7" />
                </svg>
              ) : (
                i + 1
              )}
            </div>
            <span className={`text-[13px] font-medium ${active ? 'text-ink-900' : done ? 'text-ink-600' : 'text-ink-400'}`}>
              {step}
            </span>
          </div>
          {i < steps.length - 1 && (
            <div className={`flex-1 h-px min-w-8 ${done ? 'bg-forest-900' : 'bg-ink-200'}`} />
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default Stepper;
